import React from 'react'
import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

const PopupMessages = () => {
  const {
    adminMessage, 
		setAdminMessage
  } = useContext(AppContext);

  const closeModal = () => {
    setAdminMessage(null);
    document.getElementById('idAdminMessages').style.display='none';
  };

  return (
    <div id="idAdminMessages" className="modal">
      <form className="modal-content">
        <div className="container">
          <h1>Message</h1>
          <p>
            {adminMessage}
          </p>

          <div className="RowContBntsCCP" style={{justifyContent: 'center'}}>
            <div className="Btns BtnDeposit" onClick={closeModal}>
              Ok
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default PopupMessages;